import {
    FETCH_ORG_SURVEY_ANSWERS,
    FETCH_ORG_SURVEY_ANSWERS_SUCCESS,
    HIDE_ORG_SURVEY_ANSWERS_LOADER,
    SHOW_ORG_SURVEY_ANSWERS_LOADER,
    ON_SAVE_ORG_SURVEY_ANSWERS,
    ON_SAVE_ORG_SURVEY_ANSWERS_SUCCESS,
    SHOW_ORG_SURVEY_ANSWERS_MESSAGE,
    HANDLE_ORG_SURVEY_ANSWER_MESSAGE_CLOSE,
} from 'constants/ActionTypes';

export const fetchOrgSurveyAnswers = (payload) => {
    return {
        type: FETCH_ORG_SURVEY_ANSWERS,
        payload
    };
};

export const fetchOrgSurveyAnswersSuccess = (payload) => {
    return {
        type: FETCH_ORG_SURVEY_ANSWERS_SUCCESS,
        payload
    };
};
export const showOrgSurveyAnswersMessage = (message) => {
    return {
        type: SHOW_ORG_SURVEY_ANSWERS_MESSAGE,
        payload: message
    };
};
export const onSaveOrgSurveyAnswers = (payload) => {
    return {
        type: ON_SAVE_ORG_SURVEY_ANSWERS,
        payload
    };
};
export const onSaveOrgSurveyAnswersSuccess = (data) => {
    return {
        type: ON_SAVE_ORG_SURVEY_ANSWERS_SUCCESS,
        payload: data
    };
};
export const showOrgSurveyAnswersLoader = () => {
    return {
        type: SHOW_ORG_SURVEY_ANSWERS_LOADER,
    };
};
export const hideOrgSurveyAnswersLoader = () => {
    return {
        type: HIDE_ORG_SURVEY_ANSWERS_LOADER,
    };
};
export const handleAnswersMessageClose = () => {
    return {
        type: HANDLE_ORG_SURVEY_ANSWER_MESSAGE_CLOSE,
    };
};



// WEBPACK FOOTER //
// ./actions/OrgSurveyAnswers.js